import React, { useContext } from 'react';
import classNames from 'classnames';
import ShareableLinkDocumentsContext from 'router/subrouters/ShareableLink/providers/ShareableLinkDocuments/ShareableLinkDocuments.context';
import FolderPath from 'components/FolderPath';

import './ShareableLinkPath.styles.scss';

type ShareableLinkPathProps = {
  className?: string;
};

const ShareableLinkPath: React.FC<ShareableLinkPathProps> = (props) => {
  const { className } = props;

  const { documentRoute, baseDocsPath } = useContext(
    ShareableLinkDocumentsContext,
  );

  const classes = classNames('shareable-link-path', className);

  return (
    <div className={classes}>
      <FolderPath route={documentRoute} basePath={baseDocsPath} />
    </div>
  );
};

export default ShareableLinkPath;
